import React from 'react';
import Link from '@atlaskit/primitives/anchor';

export const Anchor = ({ children, href }: { children: React.ReactNode; href: string }) => (
	<Link href={href} target="_blank">
		{children}
	</Link>
);
